import { create, type StoreApi, type UseBoundStore } from "zustand";
import { persist } from "zustand/middleware";

interface BoardState {
  slug: string;
  setSlug: (slug: string) => void;
}

export const useBoardStore: UseBoundStore<StoreApi<BoardState>> =
  create<BoardState>()(
    persist(
      (set) => ({
        slug: "a",
        setSlug: (slug: string) => set({ slug }),
      }),
      { name: "aimg-board" },
    ),
  );
